<template>
  <page-section
    :section-name="name"
    :content="textContent"
    wrapper-class="bg-white py-6"
  >
    <template #header="{ content }">
      <div class="container mx-auto px-6 flex items-end flex-col">
        <h2 v-html="content.title" class="lowercase text-green" />
      </div>
    </template>
    <template v-slot="{ content }">
      <p v-html="content.body[0]" />
      <fade-shift>
        <div class="image-grid py-6">
          <img
            src="../assets/images/Photos/Celebrating_our_donor_community/susan_wismer.jpg"
            :alt="$t('i18nAlt[31]')"
          />
          <img
            src="../assets/images/Photos/Celebrating_our_donor_community/susan_formosa_2a.jpg"
            :alt="$t('i18nAlt[32]')"
          />
        </div>
      </fade-shift>
      <pull-quote
        :credit="content.quotes[0].credit"
        class="lg:w-2/4 lg:inline-block"
      >
        {{ content.quotes[0].body }}
      </pull-quote>
      <pull-quote
        :credit="content.quotes[1].credit"
        class="lg:w-2/4 lg:inline-block"
      >
        {{ content.quotes[1].body }}
      </pull-quote>
    </template>
    <template #footer="{ content }">
      <div class="quote-grid container mx-auto p-6">
        <pull-quote :credit="content.quotes[2].credit" class="mr-0">
          {{ content.quotes[2].body }}
        </pull-quote>
        <fade-shift>
          <img
            src="../assets/images/Photos/Celebrating_our_donor_community/anne_christians.jpg"
            :alt="$t('i18nAlt[33]')"
          />
        </fade-shift>
      </div>
      <pull-quote class="py-4" :credit="content.quotes[3].credit">
        {{ content.quotes[3].body }}
      </pull-quote>
      <div class="bg-white w-100">
        <div
          class="fact-grid container mx-auto px-6 pt-8 text-2xl font-sans leading-6"
        >
          <fade-shift class="three-concerns relative">
            <span v-html="content.facts['3Concerns'].body" />
            <div class="fact-icon relative flex items-center justify-center">
              <img
                src="../assets/images/water_colour_circle.png"
                role="presentation"
              />
              <img
                src="../assets/images/Photos/Celebrating_our_donor_community/3.svg"
                role="presentation"
                class="absolute icon"
              />
            </div>
            <ol class="list-decimal list-inside">
              <li
                v-for="item of content.facts['3Concerns'].list"
                :key="item"
                v-html="item"
                class="leading-8"
              />
            </ol>
          </fade-shift>
          <fade-shift class="six-eight-donate relative">
            <div class="fact-icon relative flex items-center justify-center">
              <img
                src="../assets/images/water_colour_circle.png"
                role="presentation"
              />
              <img
                src="../assets/images/Photos/Celebrating_our_donor_community/money.svg"
                role="presentation"
                class="absolute icon"
              />
            </div>
            <span v-html="content.facts['68Donate'].body" />
          </fade-shift>
          <fade-shift class="eight-two-donate relative">
            <div class="fact-icon relative flex items-center justify-center">
              <img
                src="../assets/images/water_colour_circle.png"
                role="presentation"
              />
              <img
                src="../assets/images/Photos/Celebrating_our_donor_community/world-hand.svg"
                role="presentation"
                class="absolute icon"
              />
            </div>
            <span v-html="content.facts['82Donate'].body" />
          </fade-shift>
          <fade-shift class="four-eight-volunteer relative">
            <div class="fact-icon relative flex items-end justify-center">
              <img
                src="../assets/images/Photos/Celebrating_our_donor_community/volunteers.svg"
                role="presentation"
              />
            </div>
            <span v-html="content.facts['48Volunteer'].body" />
          </fade-shift>
          <fade-shift class="seven-six-rabble relative">
            <div class="fact-icon relative flex items-center justify-center">
              <img
                src="../assets/images/water_colour_circle.png"
                role="presentation"
              />
              <img
                src="../assets/images/Photos/Celebrating_our_donor_community/protest.svg"
                role="presentation"
                class="absolute icon"
              />
            </div>
            <span v-html="content.facts['76Rabble'].body" />
          </fade-shift>
        </div>
      </div>
    </template>
  </page-section>
</template>

<script>
export default {
  name: "CelebratingOurDonorCommunity",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    pullQuote: () => import("@/components/PullQuote.vue"),
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  data() {
    return {
      name: "celebratingOurDonorCommunity",
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
};
</script>

<style lang="scss">
#page-celebratingOurDonorCommunity {
  h2 {
    small {
      margin-left: 2rem;

      @screen lg {
        margin-left: 4rem;
      }
    }
  }
}

.image-grid,
.quote-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 2fr;
  gap: 0.5rem;

  @screen md {
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr;
  }
}

.fact-grid {
  display: grid;
  grid-template-areas:
    "three-concerns"
    "six-eight-donate"
    "eight-two-donate"
    "four-eight-volunteer"
    "seven-six-rabble";
  grid-template-columns: 1fr;
  grid-template-rows: repeat(auto);
  gap: 1rem;

  @screen lg {
    grid-template-areas:
      "three-concerns three-concerns three-concerns six-eight-donate"
      "eight-two-donate four-eight-volunteer spacer six-eight-donate"
      "eight-two-donate four-eight-volunteer seven-six-rabble seven-six-rabble";
    grid-template-columns: 2fr 3fr 1fr 4fr;
    grid-template-rows: 2fr 1fr 3fr;
  }

  > * {
    @apply p-3;

    gap: 0.5rem;

    img {
      width: 6rem;

      &.icon {
        width: 4.5rem;
      }
    }
  }

  .fact-icon {
    align-self: flex-start;
  }

  .three-concerns {
    display: grid;
    grid-area: three-concerns;
    grid-template-columns: 1fr 6rem;
    grid-template-rows: auto auto;

    > span {
      grid-column-start: 1;
    }

    > div {
      grid-column-start: 2;
      grid-row-start: span 2;
    }

    > ol {
      grid-column-start: 1;
    }

    .icon {
      bottom: 0;
    }

    @screen lg {
      grid-template-columns: 2fr 6rem 4fr;
      grid-template-rows: 1fr;

      > span {
        grid-column-start: auto;
      }

      > div {
        grid-column-start: auto;
        grid-row-start: auto;
      }

      > ol {
        grid-column-start: auto;
      }

      &::before {
        content: " ";
        position: absolute;
        top: 0;
        left: 60%;
        width: 3px;
        height: 20rem;
        transform: rotate(90deg);
        background-image: url("../assets/images/dotted_line-long.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
        background-size: 100%;
      }
    }
  }

  .six-eight-donate {
    display: grid;
    grid-area: six-eight-donate;
    grid-template-columns: 6rem 3fr;
    grid-template-rows: 1fr;

    @screen lg {
      &::before {
        content: " ";
        position: absolute;
        top: 1rem;
        left: -1rem;
        width: 3px;
        height: 10rem;
        background-image: url("../assets/images/dotted_line-long.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
        background-size: 100%;
      }
    }
  }

  .eight-two-donate {
    display: grid;
    grid-area: eight-two-donate;
    grid-template-columns: 6rem 2fr;
    grid-template-rows: 1fr;

    @screen lg {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 2fr;

      &::before {
        content: " ";
        position: absolute;
        top: 2rem;
        right: 0;
        width: 3px;
        height: 10rem;
        background-image: url("../assets/images/dotted_line-long.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
        background-size: 100%;
      }

      > span {
        grid-row-start: 2;
      }

      .fact-icon {
        position: absolute;
        top: -1rem;
      }
    }
  }

  .four-eight-volunteer {
    display: grid;
    grid-area: four-eight-volunteer;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;

    .fact-icon {
      align-self: center;
    }

    img {
      width: 100%;
    }

    @screen lg {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;

      &::before {
        content: " ";
        position: absolute;
        top: 2rem;
        right: 0;
        width: 3px;
        height: 10rem;
        background-image: url("../assets/images/dotted_line-long.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
        background-size: 100%;
      }
    }
  }

  .seven-six-rabble {
    display: grid;
    grid-area: seven-six-rabble;
    grid-template-columns: 6rem 3fr;
    grid-template-rows: 1fr;

    @screen lg {
      &::before {
        content: " ";
        position: absolute;
        top: -8rem;
        left: 60%;
        width: 3px;
        height: 14rem;
        transform: rotate(90deg);
        background-image: url("../assets/images/dotted_line-long.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-origin: content-box;
        background-size: 100%;
      }

      > span {
        grid-column-start: 2;
      }

      .fact-icon {
        position: absolute;
        top: -3rem;
      }
    }
  }
}
</style>
